import script from "./AddThumb.vue?vue&type=script&setup=true&lang=js"
export * from "./AddThumb.vue?vue&type=script&setup=true&lang=js"

import "./AddThumb.vue?vue&type=style&index=0&id=7e1d06da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e1d06da"]])

export default __exports__